import React, { useState } from "react"
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core"
import {
  PinDrop,
  Email,
  Phone,
  Facebook,
  Twitter,
  LinkedIn,
  Instagram,
} from "@material-ui/icons"
import { Alert, AlertTitle } from "@material-ui/lab"

import imageContact from "images/contact.jpg"
import TitrePage from "../components/titrePage"
import { useTranslation } from "react-i18next"
import useForm from "../lib/useForm"

export default function Contact() {
  const classes = useStyles()
  const { t } = useTranslation()
  const [emailSent, setEmailSent] = useState(false)

  const { values, updateValue } = useForm({
    name: "",
    email: "",
    telephone: "",
    object: "",
    message: "",
  })

  const submitForm = async e => {
    e.preventDefault()
    const body = JSON.stringify(values)
    // console.log("body", body)
    // const response =
    await fetch(
      "https://9kk5rlyv39.execute-api.eu-west-1.amazonaws.com/send_email_wsc",
      {
        mode: "no-cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      }
    )
    // console.log("response", response)
    setEmailSent(true)
  }

  return (
    <section className={classes.section}>
      <TitrePage titre="menu.contact" />
      <Container className={classes.container}>
        <Card className={classes.contactBox}>
          <Grid container direction="row" spacing={0}>
            <Grid item sm={12} md={6}>
              <CardContent className={classes.content}>
                {!emailSent && (
                  <div>
                    <TextField
                      label={t("contact.nom")}
                      placeholder="William Schlegel"
                      name="name"
                      value={values.name}
                      onChange={updateValue}
                      fullWidth
                    />
                    <TextField
                      label={t("contact.email")}
                      placeholder="william@wsconseil.com"
                      name="email"
                      value={values.email}
                      onChange={updateValue}
                      fullWidth
                    />
                    <TextField
                      label={t("contact.telephone")}
                      placeholder="+33 (0)6 20 09 71 42"
                      name="telephone"
                      value={values.telephone}
                      onChange={updateValue}
                      fullWidth
                    />
                    <TextField
                      label="Object"
                      placeholder="Object"
                      name="object"
                      value={values.object}
                      onChange={updateValue}
                      fullWidth
                      className={classes.honneypot}
                    />
                    <TextField
                      label={t("contact.message")}
                      multiline
                      rows={4}
                      name="message"
                      value={values.message}
                      onChange={updateValue}
                      fullWidth
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      role="submit"
                      onClick={submitForm}
                    >
                      {t("contact.envoyer")}
                    </Button>
                  </div>
                )}
                {emailSent && (
                  <Alert severity="success" style={{ marginTop: "1rem" }}>
                    <AlertTitle>{t("contact.success")}</AlertTitle>
                  </Alert>
                )}
              </CardContent>
            </Grid>
            <Grid item sm={false} md={6}>
              <CardMedia image={imageContact} className={classes.media}>
                <Typography variant="h5" className={classes.h5}>
                  {t("contact.titre")}
                </Typography>
                <Typography variant="body2">{t("contact.texte")}</Typography>
                <List>
                  <ListItem
                    button
                    component="a"
                    href="https://goo.gl/maps/vHXTKhujDsv"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ListItemIcon>
                      <PinDrop style={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText primary="Valmondois (95) France" />
                  </ListItem>
                  <ListItem
                    button
                    component="a"
                    href="mailto:contact@wsconseil.com"
                  >
                    <ListItemIcon>
                      <Email style={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText primary="contact@wsconseil.com" />
                  </ListItem>
                  <ListItem button component="a" href="tel:+33620097142">
                    <ListItemIcon>
                      <Phone style={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText primary="+33 (0)6 20 09 71 42" />
                  </ListItem>
                </List>
                <div className={classes.social}>
                  <IconButton
                    className={classes.socialButton}
                    component="a"
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Facebook />
                  </IconButton>
                  <IconButton
                    className={classes.socialButton}
                    component="a"
                    href="https://www.twitter.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Twitter />
                  </IconButton>
                  <IconButton
                    className={classes.socialButton}
                    component="a"
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedIn />
                  </IconButton>
                  <IconButton
                    className={classes.socialButton}
                    component="a"
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Instagram />
                  </IconButton>
                </div>
              </CardMedia>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </section>
  )
}

const useStyles = makeStyles(theme => ({
  section: {
    backgroundColor: theme.palette.bgLight,
    color: theme.palette.primary.main,
  },
  container: {
    display: "flex",
    justifyContent: "center",
  },
  contactBox: {
    display: "flex",
    width: "70%",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: "4rem",
  },
  content: {
    flex: "1 0 auto",
    flexWrap: "wrap",
  },
  media: {
    width: "100%",
    color: "white",
    padding: "2rem",
  },
  h5: {
    marginBottom: "0.5rem",
  },
  button: {
    marginTop: "1.5rem",
  },
  honneypot: {
    display: "none",
  },
  social: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  socialButton: {
    color: "white",
    border: "white 1px solid",
    borderRadius: "50%",
    padding: "0.5rem",
    margin: "2rem 0.5rem",
  },
}))
